<p-columnFilter matchMode="equals" showClearButton="false" showMatchModes="false" type="numeric" [field]="field"
  showMenu="false">
  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
    <p-inputnumber [formControl]="control" mode="decimal" [useGrouping]="false" [min]="1" (onBlur)="filterInput($event)"
      size="small" placeholder="Escribir" />
  </ng-template>
</p-columnFilter>